
import colorFunction from 'css-color-function'
type ColorValue = string
const formula: { [key: string]: string } = {
    'dark-2': 'color(primary shade(10%))',
    'light-1': 'color(primary tint(10%))',
    'light-2': 'color(primary tint(20%))',
    'light-3': 'color(primary tint(30%))',
    'light-4': 'color(primary tint(40%))',
    'light-5': 'color(primary tint(50%))',
    'light-6': 'color(primary tint(60%))',
    'light-7': 'color(primary tint(70%))',
    'light-8': 'color(primary tint(80%))',
    'light-9': 'color(primary tint(90%))'
}
const generateColors = (primary: string): { [key: string]: ColorValue } => {
    const colors: { [key: string]: ColorValue } = {}
    // 遍历 formula 的键
    for (const key in formula) {
        if (formula.hasOwnProperty(key)) {
            // 替换 'primary' 并转换颜色值
            const value = formula[key].replace(/primary/g, primary)
            colors[key] = colorFunction.convert(value)
        }
    }
    // 返回颜色对象
    return colors
}
export default generateColors
